<template src="./Index.html">
</template>
<script>
import logo from '@/assets/clinic-logo-transparent.png'

export default {
  created() {
    this.logo = logo
    let id = this.$route.params.id;
    this.$store
      .dispatch("invoices/getForPrint", id)
      .then((res) => {
        this.item = res;
      }).catch(() => { });
  },
  data() {
    return {
      logo: null,
      item: {},

    };
  },
  computed: {
    user() {
      return this.$store.state.security.user;
    },
    totalAmount() {
      if (this.item.services.length == 0) return 0;
      else {
        var sum = 0;
        this.item.services.forEach(x => {
            sum += (x.discount > 0 &&  x.discount != null )? (x.price -(x.price * (x.discount / 100))):x.price ;
            //sum += (x.price * (x.discount / 100))
       });
        if (this.item.discountType == 1 && this.item.discount != null) sum -= this.item.discount;
        else if (this.item.discountType == 2 && this.item.discount != null) sum -= sum * (this.item.discount / 100);
        return sum;
      }
    },
  },
  methods: {
    printReceipt() {
      window.print(); // فتح نافذة الطباعة
    },
  },
};
</script>
<style>
.stamp {
  position: absolute;
  bottom: 200px;
  /* مسافة من الأسفل */
  left: 50%;
  transform: translateX(-50%) rotate(-8deg);
  /* إضافة ميلان */
  padding: 15px 25px;
  border: 3px solid red;
  border-radius: 8px;
  font-size: 20px;
  font-weight: bold;
  color: red;
  background: white;
  width: 250px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  opacity: 0.9;
}

.stamp .details {
  font-size: 12px;
  font-weight: normal;
  margin-top: 8px;
}


/* //-------------------------------------------- */
.contact-footer {
  position: absolute;
  bottom: 5px;
  /* يضمن الابتعاد عن الحافة السفلية */
  left: 0;
  right: 0;
  font-size: 14px;
  color: #555;
  /* لون النص */
}

.clinic-name {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  /* لون أزرق غامق */
  margin: 0;
}

.receipt-title {
  font-size: 16px;
  font-weight: bold;
  color: #83c783;
  /* لون أزرق */
}

/* تهيئة التصميم للطباعة بحجم A4 */
.receipt-a4 {
  width: 210mm;
  /* عرض A4 */
  min-height: 290mm;
  /* ارتفاع A4 */
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

/* إعداد الطباعة */
@media print {
  .receipt-a4 {
    box-shadow: none;
    margin: 0;
  }

  body {
    margin: none;
  }

  .v-btn {
    display: none;
    /* إخفاء زر الطباعة عند الطباعة */
  }
}

.total {
  color: #83c783;
}

h4,
h5,
span {
  font-family: "Almarai";
}

.text-caption {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}



.invoice-table {
  width: 30%;
  /* يظل 50% من العرض */
  margin-left: 0;
  /* محاذاة إلى اليسار */
  margin-right: auto;
  /* يدفع الجدول لليسار */
  border-collapse: collapse;
  direction: rtl;
  /* النص عربي */
  font-weight: bold;
  color: #0b293c;
}

/* نزيل أي حدود افتراضية */
.invoice-table,
.invoice-table th,
.invoice-table td {
  border: none;
  outline: none;
  background: transparent;
}

/* صفوف وخلية العنوان (البداية الثابتة) */
.invoice-table th {
  text-align: right;
  /* لأن العناوين عربية */
  padding: 8px 8px;
  min-width: 150px;
  /* تعديل هذا لتغيير عرض العمود الثابت */
  white-space: nowrap;
  font-weight: bold;
}

/* خلية القيم تكون على اليمين أيضاً، والأرقام من اليسار لليمين */
.invoice-table td {
  text-align: right;
  padding: 8px 8px;
  white-space: nowrap;
  /* يمنع انقسام الرقم إلى سطرين */
}
</style>
